import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import EmailBack from '../EmailBack/EmailBack';
import ProductListItem from './ProductListItem.js';

import { getActiveListingPage } from '../../reduck/selectors';
import {
  convertDefaultChannelsAvailabilityForSponsoredProduct,
  getDefaultDeliveriesAndCollectionForProduct
} from '../../dataConverters/defaultChannelsAvailabilitiesConverter';

const ListOnLoadBeacon = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

class ProductList extends PureComponent {
  render() {
    const { productsList, sponsoredProducts, countdownClassSuffix,
      emailWhenBackFormProductID } = this.props;

    let productListWithSponsoredProducts;

    if (sponsoredProducts?.items) {
      // we must not show a regular product if it is also contained in sponsored products,
      // because the product would be shown twice on the listing page
      productListWithSponsoredProducts =
        productsList.filter((currentProduct) => (
          !sponsoredProducts.items.map((sponsoredProduct) => sponsoredProduct.id).includes(currentProduct.id)
        ));

      // adding sponsored products to the product list
      productListWithSponsoredProducts.splice(4, 0, ...sponsoredProducts.items);
      
    } else {
      // no sponsored products, so we show only show productList
      productListWithSponsoredProducts = productsList;
    }


    return (
      <>
        <div>
          {productListWithSponsoredProducts.map((currentProduct, i) => (
            <Fragment key={`${currentProduct.id}${currentProduct.sponsored ? '-sponsored' : ''}`}>
              <ProductListItem
                {...currentProduct}
                defaultChannelsAvailability={
                  currentProduct.sponsored
                    ? convertDefaultChannelsAvailabilityForSponsoredProduct(currentProduct.deliveryOptions)
                    : getDefaultDeliveriesAndCollectionForProduct(currentProduct)
                }
                countdownClassSuffix={countdownClassSuffix}
                dataInteraction={currentProduct.sponsored ? 'hookLogic' : undefined}
                loadImagesLazily={i > 0}
              />
              {
                (currentProduct.id === emailWhenBackFormProductID)
                  ? <EmailBack key={`email-back-${currentProduct.id}`} />
                  : null
              }
            </Fragment>
          ))}
        </div>
        {sponsoredProducts?.onLoadBeacon
          ? (
            <ListOnLoadBeacon className={'list-on-load-beacon'} src={sponsoredProducts.onLoadBeacon} alt={'beacon'} />
          ) : null }
      </>
    );
  }
}

ProductList.displayName = 'ProductList';

ProductList.propTypes = {
  productsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  sponsoredProducts: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    onLoadBeacon: PropTypes.string.isRequired
  }),
  countdownClassSuffix: PropTypes.string,
  emailWhenBackFormProductID: PropTypes.string
};

ProductList.defaultProps = {
  sponsoredProducts: null,
  countdownClassSuffix: undefined,
  emailWhenBackFormProductID: undefined
};

function mapStateToProps(state) {

  return {
    productsList: getActiveListingPage(state).productList,
    sponsoredProducts: getActiveListingPage(state).sponsoredProducts ? getActiveListingPage(state).sponsoredProducts : null,
    countdownClassSuffix: state.listingPage.commonData.countdownClassSuffix,
    emailWhenBackFormProductID: state.listingPage.commonData.emailWhenBackFormProductID
  };
}

export default connect(mapStateToProps)(ProductList);
